export class ArbetsorderHeaderLisRowTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        violIngenAccepterad: "Ingen accepterad"
    };
}
